import { CssVarsProvider, extendTheme } from '@mui/joy/styles';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import LandingPage from './pages/LandingPage';
import ServicesPage from './pages/ServicesPage';
import AboutPage from './pages/AboutPage';
import ScrollToTop from './components/common/ScrollToTop';
import { HelmetProvider } from 'react-helmet-async';
import SEO from './components/common/SEO';
// Import policy components
import TermsOfService from './components/policy/TermsOfService';
import Refund from './components/policy/Refund';
import Cancellation from './components/policy/Cancellation';
import UseRestrictions from './components/policy/UseRestrictions';
import Privacy from './components/policy/Privacy';
import OurWork from './components/policy/OurWork';
import Footer from './components/layout/Footer';
import CareersPage from './pages/CareersPage';

const theme = extendTheme({
    fontFamily: {
        body: "'TikTok Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, system-ui, sans-serif",
        display: "'TikTok Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, system-ui, sans-serif",
        code: "'TikTok Sans', ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace"
    },
    colorSchemes: {
        light: {
            palette: {
                background: {
                    body: '#fff',
                    level1: '#f5f5f5',
                },
                text: {
                    primary: '#1a237e',
                    secondary: '#555',
                },
            },
        },
        dark: {
            palette: {
                background: {
                    body: '#132f4c',
                    level1: '#132f4c',
                },
                text: {
                    primary: '#fff',
                    secondary: '#b0bec5',
                },
                primary: {
                    main: '#90caf9',
                },
            },
        },
    },
});

function FooterSlot() {
  const location = useLocation();
  if (location.pathname === '/') return null;
  return <Footer />;
}

function App() {
  return (
    <HelmetProvider>
        <CssVarsProvider 
            theme={theme}
            defaultMode="light"
            modeStorageKey="hubitable-color-scheme"
            disableNestedContext
        >
            {/* Global SEO settings */}
            <SEO 
              title="Hubitable | Your Personal AI Assistant for a Healthy Lifestyle"
              description="Hubitable helps you achieve a healthier lifestyle with personalized AI assistance for nutrition, fitness, and wellness."
              keywords="AI assistant, healthy lifestyle, nutrition app, fitness tracking, wellness app"
              ogImage="/logo.png"
            />
            
            <Router>
                <ScrollToTop />
                <div className="App" style={{ 
                    backgroundColor: 'var(--joy-palette-background-body)',
                    color: 'var(--joy-palette-text-primary)',
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <Navbar />
                    <div style={{ flex: 1 }}>
                        <Routes>
                            <Route path="/" element={<LandingPage title="Hubitable | Your Personal AI Assistant for a Healthy Lifestyle" />} />
                            <Route path="/services" element={<ServicesPage title="Hubitable | Services" />} />
                            <Route path="/about" element={<AboutPage title="Hubitable | About" />} />
                            {/* Policy Routes */}
                            <Route path="/terms" element={<TermsOfService title="Hubitable | Terms of Service" />} />
                            <Route path="/terms/refund" element={<Refund title="Hubitable | Refund Policy" />} />
                            <Route path="/terms/cancellation" element={<Cancellation title="Hubitable | Cancellation Policy" />} />
                            <Route path="/terms/use_restrictions" element={<UseRestrictions title="Hubitable | Use Restrictions" />} />
                            <Route path="/privacy" element={<Privacy title="Hubitable | Privacy Policy" />} />
                            <Route path="/about/our-work" element={<OurWork title="Hubitable | Our Work" />} />
                            <Route path="/careers" element={<CareersPage title="Hubitable | Careers" />} />
                        </Routes>
                    </div>
                    <FooterSlot />
                </div>
            </Router>
        </CssVarsProvider>
    </HelmetProvider>
  );
}

export default App;
